export default __webpack_public_path__ + "static/safe_checkout-af02f18130bb8d6d7c804e1a6876bc86.png";